import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import IncidentDetails from '../components/IncidentDetails';
import StatusApiError from '../components/StatusApiError';
import useIncident from '../hooks/useIncident';

function IncidentPage() {
  const { incidentId } = useParams();
  const { loading, items, error } = useIncident(incidentId);
  const item = items.find((i) => i.data.attributes.public_id === Number(incidentId));

  let content = null;
  if (!loading && error) {
    content = <StatusApiError error={error} message="Incident details are unavailable." />;
  } else if (!loading && !item) {
    content = (
      <Typography sx={{ m: 4 }} style={{ textAlign: 'center' }}>
        Incident not found.
      </Typography>
    );
  } else if (!loading) {
    content = <IncidentDetails item={item} />;
  }

  return <div style={{ paddingTop: 90 }}>{content}</div>;
}

export default IncidentPage;
